(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const buttonElement = document.querySelector('.mobile-search-bar');
    buttonElement?.addEventListener('click', function () {
      var summaryElement = document.querySelector('.mobile-search summary');
      var searchDetails = document.querySelector('.mobile-search .header__search > details');
      console.log('mobile serch clicked', summaryElement, searchDetails);
      summaryElement.dispatchEvent(new PointerEvent('pointerdown'));
      summaryElement.dispatchEvent(new PointerEvent('pointermove', { movementX: 1, movementY: 1 }));
      summaryElement.dispatchEvent(new PointerEvent('pointerup'));
      searchDetails.setAttribute('open', true);
      searchDetails.querySelector('.search__input').focus();
    });
  })();

  function openSearch(event) {
    console.log('serch opened');
    event.preventDefault();
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      let backTop = document.querySelector('.back-to-top');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        backTop.style.display = 'flex';
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        backTop.style.display = 'none';
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lt-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function () {
    const button = document.querySelector('.product-form__buttons');
    const div = document.querySelector('.sticky-add-cart');

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        // Check if the bottom of the button is above the top of the viewport
        if (entry.boundingClientRect.bottom < 0 && window.innerWidth < 768) {
          div.style.display = 'block';
        } else {
          div.style.display = 'none';
        }
      },
      { threshold: 0 }
    );

    observer.observe(button);

    const header = document.querySelector('.shopify-section-header-sticky');

    div.addEventListener('click', (e) => {
      button.querySelector('.product-form__submit').click();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const clickableDivs = document.querySelectorAll('.m02-slides');

    for (const div of clickableDivs) {
      const link = div.querySelector('a');
      div.addEventListener('click', () => {
        link?.click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m09"] && !Shopify.designMode) return;
  try {
    
  const selectElement = document.getElementById('m09-select'); // Replace with your select element's ID
  const stickyDiv = document.querySelector('.m09');
  const content = document.querySelector('.m09-parent');

  let lastScrollTop = 0;

  window.addEventListener('scroll', function () {
    const currentScrollTop = window.scrollY;

    // Check if scrolling down
    if (currentScrollTop > lastScrollTop) {
      if (currentScrollTop > stickyDiv.offsetTop) {
        stickyDiv.classList.add('sticky');
      } else {
        stickyDiv.classList.remove('sticky');
      }
    } else {
      // Scrolling up, always remove sticky class
      stickyDiv.classList.remove('sticky');
    }

    lastScrollTop = currentScrollTop;
  });

  // CSS for sticky behavior

  selectElement.addEventListener('change', function () {
    const selectedValue = this.value;
    const targetDiv = document.getElementById(selectedValue);

    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Handle scenario where no div with matching ID is found (optional)
      console.warn('No div found with ID:', selectedValue);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Target the node that will be observed for mutations
    const targetNode = document.querySelector('product-recommendations');
    const recommendLoader = document.getElementById('recommend-loader');
    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          var recommendationSlider = new Splide('#recommend').mount();
          recommendLoader.style.display = 'none';
          observer.disconnect();
        }
      }
    };
    // Create an instance of the MutationObserver with the callback
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    if (targetNode) {
      observer.observe(targetNode, config);
    } else {
      console.error('The target element for product recommendations does not exist.');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
